import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { Global } from '../../../app/shared/global';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { retry, catchError } from 'rxjs/operators';

@Injectable()
export class DataService {
    constructor(private _http: HttpClient) { }

    get(url: string): Observable<any> {
        const currentUser = JSON.parse(sessionStorage.getItem('currentUser')!);
        console.log("currentUser:", currentUser)
        const userId =  currentUser?.userid;
        let headers = new HttpHeaders();
        headers = headers.append(Global.PPAAuthHeaderName, Global.PPAAuthHeaderValue);
        if (userId) {
            headers = headers.append("UserId", userId);
        }
        headers = headers.append('Content-Type', 'application/json');
        return this._http.get(url, { headers: headers, responseType: 'json' }).pipe(
            retry(1),
            catchError(this.handleError)
        )
    }

    post(url: string, model: any): Observable<any> {
        const currentUser = JSON.parse(sessionStorage.getItem('currentUser')!);
        console.log("currentUser:", currentUser)
        const userId =  currentUser.userid;
        let body = JSON.stringify(model);
        let headers = new HttpHeaders();
        headers = headers.append(Global.PPAAuthHeaderName, Global.PPAAuthHeaderValue);
        if (userId) {
            headers = headers.append("UserId", userId);
        }        
        headers = headers.append('Content-Type', 'application/json');
        return this._http.post(url, body, { headers: headers, responseType: 'json' }).pipe(
            retry(1),
            catchError(this.handleError)
        )
    }

    private handleError(error: any) {
        console.error(error);
        return throwError(() => (error?.error || 'Server error'));
    }
}